import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css';

import * as echarts from 'echarts'
import 'echarts-gl';
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n)
// var language =  window.navigator.language == "zh-CN" ? 'zh' : 'en';
// sessionStorage.setItem('yy',language);
const language = localStorage.getItem('yy') || 'zh'
// localStorage.setItem('yy',language);
const i18n = new VueI18n({
  locale: language, 
  messages: {
    en:require('./locales/en.json'),
    zh:require('./locales/zh.json'),
  }
})

Vue.prototype.$bus = new Vue();
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  beforeCreate () {
    Vue.prototype.$bus = this   // 安装全局事件总线
  }
}).$mount('#app')
